import { render, staticRenderFns } from "./RedList.vue?vue&type=template&id=eef252d0&scoped=true"
import script from "./RedList.vue?vue&type=script&lang=js"
export * from "./RedList.vue?vue&type=script&lang=js"
import style0 from "./RedList.vue?vue&type=style&index=0&id=eef252d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef252d0",
  null
  
)

export default component.exports